import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { TradeFreezedActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function TradeFreezed({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as TradeFreezedActivity

  const merchantName = activity.merchantName || '商户'

  return (
    <ItemWrapper notification={notification}>
      你的商户「{merchantName}」涉及异常交易，系统已暂停{activity.freezeType}功能，请查看详情
    </ItemWrapper>
  )
}
